module.exports = __webpack_public_path__ + "sh.87ec88935ce96731de80.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/sh.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/sh.svg
// module chunks = styles